/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const ColumnVisibilityKey = {
  CaCases: 'caCases',
  CaUsers: 'caUsers',
  CollectorCases: 'collectorCases',
  CollectorUsers: 'collectorUsers',
  ProviderAppointments: 'providerAppointments',
  SuperAdminCases: 'superAdminCases',
  SuperAdminClients: 'superAdminClients',
  SuperAdminUserSearch: 'superAdminUserSearch',
  SuperAdminAuditTrail: 'superAdminAuditTrail',
} as const;

export type ColumnVisibilityKeyType = (typeof ColumnVisibilityKey)[keyof typeof ColumnVisibilityKey];

export type ColumnVisibilityModel = Record<string, boolean>;

export type ColumnVisibilityState = Partial<Record<ColumnVisibilityKeyType, ColumnVisibilityModel>>;

const initialState: ColumnVisibilityState = {};

const columnVisibilitySlice = createSlice({
  name: 'columnVisibility',
  initialState,
  reducers: {
    setColumnVisibility: (
      state,
      action: PayloadAction<{ tableKey: ColumnVisibilityKeyType; model: ColumnVisibilityModel }>,
    ) => {
      state[action.payload.tableKey] = action.payload.model;
    },
    clearColumnVisibility: (state, action: PayloadAction<ColumnVisibilityKeyType>) => {
      delete state[action.payload];
    },
  },
});

export const { setColumnVisibility, clearColumnVisibility } = columnVisibilitySlice.actions;

export default columnVisibilitySlice.reducer;
